import { onBeforeUnmount, ref } from 'vue'

/**
 * Returns an AbortSignal that automatically aborts when the component unmounts.
 * @returns {AbortSignal} - The signal
 */
export default function useAbortController() {
	const controller = ref(new AbortController())

	onBeforeUnmount(() => {
		controller.value.abort()
	})

	return controller.value.signal
}
